// Sign-in / register card (docs/product-specs/accounts.md).

import { html, LitElement } from "lit";
import { ApiError, auth } from "../lib/api";
import { navigate, store } from "../lib/store";

export class MmLogin extends LitElement {
  private mode: "login" | "register" = "login";
  private error = "";
  private busy = false;

  override createRenderRoot(): HTMLElement {
    return this;
  }

  private async submit(e: Event): Promise<void> {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const email = (form.elements.namedItem("email") as HTMLInputElement).value;
    const password = (form.elements.namedItem("password") as HTMLInputElement)
      .value;
    this.busy = true;
    this.error = "";
    this.requestUpdate();
    try {
      const result =
        this.mode === "login"
          ? await auth.login(email, password)
          : await auth.register(email, password);
      store.set({ user: result.user });
      const me = await auth.me();
      store.set({ provider: me.provider });
      navigate("/");
    } catch (err) {
      this.error = err instanceof ApiError ? err.message : "request failed";
    } finally {
      this.busy = false;
      this.requestUpdate();
    }
  }

  private switchMode(): void {
    this.mode = this.mode === "login" ? "register" : "login";
    this.error = "";
    this.requestUpdate();
  }

  override render() {
    return html`
      <p class="eyebrow">Meeting Manager</p>
      <h1>${this.mode === "login" ? "Sign in" : "Create your account"}</h1>
      <form class="login-form" @submit=${this.submit}>
        <div>
          <label class="field-label" for="email">Email</label>
          <input id="email" name="email" type="email" required autocomplete="email" />
        </div>
        <div>
          <label class="field-label" for="password">Password</label>
          <input
            id="password"
            name="password"
            type="password"
            required
            minlength="10"
            autocomplete=${this.mode === "login" ? "current-password" : "new-password"}
          />
        </div>
        ${this.error
          ? html`<div class="message-card message-card-error"><p>${this.error}</p></div>`
          : ""}
        <button class="primary-button" ?disabled=${this.busy}>
          ${this.mode === "login" ? "Sign in" : "Register"}
        </button>
      </form>
      <p class="muted" style="margin-top: 0.9rem">
        ${this.mode === "login" ? "No account yet?" : "Already registered?"}
        <span class="navlink" @click=${this.switchMode}>
          ${this.mode === "login" ? "Register" : "Sign in"}
        </span>
      </p>
    `;
  }
}

customElements.define("mm-login", MmLogin);
